<template>
  <div
    class="modal fade"
    id="certiAccInfoRModal"
    tabindex="-1"
    aria-labelledby="certiAccInfoWModalRModallLabel"
    aria-hidden="true"
    style="overflow-x: hidden"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header text-center">
          <div class="modal_header_flex" >
            <h1 class="modal-title fs-5" id="staticBackdropLabel">
              서티라이프 멤버 정보 보기
            </h1>
          </div>
        </div>
        <div class="modal-division"/>
        <div class="modal-body" style="padding-top: 1rem">

          <div class="modalDivWrap">
            <div class="modalInputDiv">
              <label for="">이름</label>
              <span class="infoSpan">{{ managerName }}</span>
            </div>
            <div class="modalInputDiv">
              <label for="">아이디</label>
              <span class="infoSpan">{{ managerId }}</span>
            </div>
            <div class="modalInputDiv">
              <label for="">휴대폰 번호</label>
              <span class="infoSpan">{{ phoneNumberFormatter(managerPhoneNumber) }}</span>
            </div>
            <div style="height: 30px;"/>
          </div>
        </div>
        <div class="modal-footer" style="justify-content: center">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            style="color: #666666; background: #fff; border: 1px solid #666;"
          >
            닫기
          </button>
         
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { phoneNumberFormatter } from "../../utils/utils";
export default {
  data() {
    return {
      accountId: "", // 관리자 고유 id
      managerName: "", // 관리자 이름
      managerPhoneNumber: "", // 관리자 연락처
      managerId: "", // 관리자 아이디
    };
  },
  props: {
    data: {
      accountId: {
        type: String,
        required: false
      },
      managerName: {
        type: String,
        required: false
      },
      managerPhoneNumber: {
        type: String,
        required: false
      },
      managerId: {
        type: String,
        required: false
      },
    }
  },
  watch : {
    data: {
      immediate: true,
      deep: true,
      async handler(newValue, oldValue) {
        if(newValue && newValue.accountId !== this.accountId) {
          if(newValue.accountId) this.accountId = newValue.accountId;
          if(newValue.name) this.managerName = newValue.name;
          if(newValue.mobile) this.managerPhoneNumber = newValue.mobile;
          if(newValue.username) this.managerId = newValue.username;
        }
      }
    }
  },
  async mounted() {
    this.initValues();
  },
  methods: {
    phoneNumberFormatter,
    // 기타 certiAccInfoR용 utils

    // 항목 초기화 용도
    initValues() {
      this.managerName = "";
      this.managerPhoneNumber = "";
      this.managerId = "";
    },
  },
};
</script>
